// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/alertBanner/AlertBanner.scss
// module id = 2369
// module chunks = 0